export default {
  purchaseOrderLines: [],
  purchaseOrderLine: undefined,
};
